import { toast } from "sonner";
import { API_ROOT } from "@/lib/api";
import { Share2 } from "lucide-react";

export const ShareButtons = ({ slug, title }) => {
  const shareUrl = `${API_ROOT}/share/${slug}`;

  const handleShare = async () => {
    if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
      try {
        await navigator.share({ title: title || "Edilstudio", url: shareUrl });
      } catch {
        /* utente ha annullato: nessuna azione */
      }
      return;
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link copiato: incollalo dove vuoi condividerlo");
    } catch {
      toast.error("Impossibile copiare il link");
    }
  };

  return (
    <button
      type="button"
      onClick={handleShare}
      data-testid="share-native"
      className="inline-flex items-center gap-2 bg-[#2472C8] hover:bg-[#1E5FA8] text-white font-semibold text-sm px-5 py-2.5 rounded-full transition-colors"
    >
      <Share2 className="w-4 h-4" /> Condividi
    </button>
  );
};
